import React, { Component } from 'react';
import { List, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons';


class CustomerProductList extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {
        const { data, onDeletedClicked } = this.props
        return (
                <List
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={(item, ind) => (
                        <List.Item
                            actions={!onDeletedClicked ? null : [
                                <Button
                                color="danger"
                                variant="solid"
                                shape="circle"
                                size="small"
                                icon={<DeleteOutlined />}
                                onClick={() => onDeletedClicked(ind)}
                            />
                            ]}
                        >
                            <List.Item.Meta
                                title={`${item.product.name} x ${item.sale_amount}`}
                                description={`หน่วยละ ${item.sale_price} บาท`}
                            />
                        </List.Item>
                    )}
                />
        );
    }
}

export default CustomerProductList;